import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../hoc/clientOnly';

const YoutubeModal = lazy(() =>
  import(/* webpackChunkName: "YoutubeModal" */ './YoutubeModal')
);

const Loader = ({ classes, ...props }) => (
  <div className={classes}>
    <Suspense fallback={null}>
      <YoutubeModal {...props} />
    </Suspense>
  </div>
);

export default clientOnly(Loader);
